import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LocationProvider } from './contexts/LocationContext';
// Components
import TabBar from './components/common/TabBar';
import AppBar from './components/common/AppBar';
import LoginSidebar from './pages/Login/Login';

// Pages
import HomeSection from './pages/Home/HomeSection';
import LabTestsSection from './pages/Pharmacy/PharmacyProducts';
import MedicinesSection from './pages/Pharmacy/PharmacyProducts';
import DoctorsSection from './pages/Doctors/DoctorList';
import LabDetailScreen from './pages/Labs/LabDetails';
import LocationSearch from './pages/Home/LocationSearch'
import CartScreen from './pages/Labs/Cart'

import BookingScreen from './pages/Labs/Booking'
import  AboutUsScreen from './pages/Home/About'
 import TermsAndConditions from './pages/Home/TermsAndConditions'

 import PrivacyPolicy from './pages/Home/PrivacyPolicy'

const App = () => {
  // Authentication State
  const [loggedIn, setLoggedIn] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false); // Controls Login Sidebar visibility

  // Check if user is logged in using localStorage
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      setLoggedIn(true); // Mark as logged in
    }
  }, []);

  return (
    <LocationProvider>
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* App Bar */}
        <AppBar loggedIn={loggedIn} setLoggedIn={setLoggedIn} onLoginClick={() => setLoginOpen(true)} />

        {/* Tab Bar */}
        <TabBar />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<HomeSection />} />
          <Route path="/lab-tests" element={<LabTestsSection />} />
          <Route path="/medicines" element={<MedicinesSection />} />
          <Route path="/doctors" element={<DoctorsSection loggedIn={loggedIn} />} />
          <Route path="/labs/:labId" element={<LabDetailScreen />} />
          <Route path="/location-search" element={<LocationSearch />} />
          <Route path="/cart" element={<CartScreen />} />
          <Route path="/booking" element={<BookingScreen />} />
  
          <Route path="/about-us" element={<AboutUsScreen />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          


          
          
        </Routes>

        {/* Login Sidebar */}
        <LoginSidebar
          open={loginOpen}
          onClose={() => setLoginOpen(false)}
          setLoggedIn={setLoggedIn}
        />
      </div>
    </Router>
    </LocationProvider>
  );
};

export default App;